export default __webpack_public_path__ + "static/media/city-hall-photo-gallery.2aaaba4e.svg";